module.exports = __webpack_public_path__ + "static/media/16UNODC2.f92f8e8c.jpg";